import React, { useState, useContext } from "react";
import { Dialog } from "@mui/material";
import { DialogClasses } from "@mui/material/Dialog/dialogClasses";
import { modalContext } from "../../../lib";
import styles from "./modal.module.scss";
import "./mui-dialog-global.css"

export interface IModalWindow {
    isOpen: boolean;
    openModal: (children: React.ReactElement, closeOnBlur?: boolean, dialogClassnames?: Partial<DialogClasses>) => void;
    close: () => void;
    dialogClassNames?: Partial<DialogClasses>;
    closeOnBlur: boolean;
    childComponent?: React.ReactElement;
}

export function useModalWindow(): IModalWindow {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [closeOnBlur, setCloseOnBlur] = useState<boolean>(true);
    const [dialogClassNames, setDialogClassNames] = useState<Partial<DialogClasses>>();
    const [childComponent, setChildComponent] = useState<React.ReactElement>();

    const close = () => {
        setIsOpen(false);
        setChildComponent(undefined);
    }

    const openModal = (component: React.ReactElement, closeOnBlur = true, dialogClassnames?: Partial<DialogClasses>) => {
        setChildComponent(component);
        setIsOpen(true);
        setCloseOnBlur(closeOnBlur);
        setDialogClassNames(dialogClassnames);
    }

    return { isOpen, close, openModal, dialogClassNames, closeOnBlur, childComponent };
}

export const AppModal: React.FC = () => {
    const { isOpen, close, dialogClassNames, childComponent, closeOnBlur } = useContext(modalContext);

    return (
        <Dialog
            open={isOpen}
            onClose={closeOnBlur ? close : undefined}
            classes={dialogClassNames}
        >
            <div className={styles.modal}>
                <div className={styles.modalContainer}>
                    {childComponent}
                </div>
            </div>
        </Dialog>
    )
}
